import styled from 'styled-components';

export const HomePage = styled.div`
  background-color: rgb(241, 241, 241);
  display: flex;
  flex-direction: column;
  height: 100vh;
  box-sizing: border-box;
`;
